import Keycloak from 'keycloak-js'
import { Config } from '@/services/ConfigService'
import WhiteLabelService from '@/services/WhiteLabel/WhiteLabelService'
import OauthProviderService from '@/services/OauthProvider/OauthProviderService'
import { store as STORE } from '@/store'

const IDENTITY_PROVIDER_MODULE_NAME = 'identity-provider'

const initOptions = {
	url: Config.VUE_APP_KEYCLOAK_URL,
	realm: Config.VUE_APP_KEYCLOAK_REALM,
	clientId: Config.VUE_APP_KEYCLOAK_CLIENT_ID,
	color: '#32a852',
	title: 'Test'
}

const _keycloak = new Keycloak(initOptions)

async function initKeycloak() {
	await WhiteLabelService.loadWhiteLabelData()
	await OauthProviderService.getOauthProviders()

	const identityProviderModuleIsActive = STORE.state.modules.list.some(module => module.name === IDENTITY_PROVIDER_MODULE_NAME)

	if (!identityProviderModuleIsActive) {
		return
	}

	await _keycloak.init({
		onLoad: 'check-sso',
		pkceMethod: 'S256'
	})
}

export function startAfterKeycloakInit(onReady) {
	return initKeycloak().finally(() => onReady())
}

const Plugin = {
	install: Vue => {
		Object.defineProperties(Vue.prototype, {
			$keycloak: {
				get() {
					return _keycloak
				}
			}
		})
	}
}

export default Plugin